import { useEffect, useState } from 'react';
import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH } from '../../constants';

type DeviceType = 'desktop' | 'tablet' | 'mobile';

export const useDeviceLayout = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop');

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      if (width <= MOBILE_MAX_WIDTH) {
        //setDeviceType('mobile');
        setDeviceType('tablet');
      } else if (width <= TABLET_MAX_WIDTH) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    checkDevice(); // Initial check
    window.addEventListener('resize', checkDevice);

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return deviceType;
};